/**
 * Detects the restaurant slug purely from the hostname subdomain.
 * No query-param or path fallbacks — subdomain IS the only routing mechanism.
 *
 * Production:
 *   yasmin.nowshin.ir  → 'yasmin'
 *   nowshin.ir         → null   (platform home)
 *   www.nowshin.ir     → null   (platform home)
 *
 * Local dev:
 *   yasmin.localhost        → 'yasmin'   (works in Chrome/Firefox without /etc/hosts)
 *   yasmin.localhost:3001   → 'yasmin'
 *   localhost               → null       (platform home)
 *   localhost:3001          → null       (platform home)
 */
export function useRestaurantSlug() {
  // hostname never includes the port number
  const hostname = window.location.hostname.toLowerCase();
  const parts    = hostname.split('.');

  const SKIP = new Set(['www', 'api', 'app', 'mail', 'ftp']);

  // ── Case 1: subdomain.localhost  (2 parts, last is 'localhost') ────────────
  //   yasmin.localhost → ['yasmin', 'localhost'] → slug = 'yasmin'
  //   localhost        → ['localhost']            → null
  if (parts.length === 2 && parts[1] === 'localhost') {
    return SKIP.has(parts[0]) ? null : parts[0];
  }

  // ── Case 2: subdomain.domain.tld  (3+ parts, production) ─────────────────
  //   yasmin.nowshin.ir → ['yasmin','nowshin','ir'] → slug = 'yasmin'
  //   nowshin.ir        → ['nowshin','ir']          → null (only 2 parts)
  if (parts.length >= 3 && !SKIP.has(parts[0]) && !/^\d+$/.test(parts[0])) {
    return parts[0];
  }

  // ── Everything else: bare localhost, bare domain, IP → platform home ──────
  return null;
}
